import {
	createActivityInitialValues,
	createActivityValidationSchema,
	type ActivityFormProject,
} from "@pages/activity/activityForm";
import { ChangeRate } from "./setupAssistantMachine.types";

export const createValidationSchema = (project: ActivityFormProject) => createActivityValidationSchema(project);

export const createInitialValues = (project: ActivityFormProject, defaultChangeRate?: ChangeRate) => {
	const { activity } = createActivityInitialValues(project, { defaultChangeRateId: defaultChangeRate?.id });
	return { activity };
};
